import { IUser } from '../../types/damTypes';
import { hasPermission } from '../../utils/permissionUtils';

export function canUseValidooExport(user: IUser | null): boolean {
  return hasPermission(user, 'assets:download') && hasPermission(user, 'validooExport:use');
}
